import {
  Activity,
  Waypoints,
  BookOpen,
  Coins,
  Combine,
  Database,
  DraftingCompass,
  GitCompareArrows,
  LayoutPanelLeft,
  PieChart,
  Send,
  Settings2,
  Puzzle,
  Sparkles,
  SquareTerminal,
  Warehouse,
  CircleHelp,
  File,
  Bot,
  Headset,
  ListStart,
  Building2,
  CreditCard,
  Package,
  FileText,
  CalendarClock,
  Table2,
  Handshake,
} from "lucide-react";

import { AiosCommandNavIcon } from "@/components/shared/aios-command-nav-icon";

export const PlatformData = {
  teams: [
    {
      name: "Implement AI",
      logo: "/logos/iai-logo.png",
    },
  ],
  navMain: [
    {
      title: "Command",
      url: "/workforce/command-team/chat",
      icon: AiosCommandNavIcon,
      description: "Executive intelligence and Command agents",
    },
    {
      title: "Workforce",
      url: "/workforce",
      icon: SquareTerminal,
      collapsible: true,
      description: "Access to the team of Agents dashboard",
      items: [
        {
          title: "Sales Team",
          url: "/workforce/sales-team/sales-agents",
          description: "Manage sales agents and campaigns",
        },
        {
          title: "Support Team",
          url: "/workforce/support-team/support-agents",
          description: "Manage support agents and lines",
        },
        {
          title: "Tasks Team",
          url: "/workforce/tasks-team/task-agents",
          description: "Manage and customise Task Agent here",
        },
        {
          title: "Computer Use Team",
          url: "/workforce/computer-use-team/computer-use-agent",
          description: "Browser and desktop automation capabilities",
        },
        {
          title: "Analyst Team",
          url: "/workforce/analyst-team/analyst-agent",
          description: "Manage and customise Analyst Agent here",
        },
      ],
    },
    {
      title: "CRM",
      url: "/crm",
      icon: LayoutPanelLeft,
      description: "Access list of clients",
    },
    // Knowledge Bases, folders of documents agents draw on. BookOpen matches
    // the agents' Settings > Knowledge Bases item so the two read as one
    // feature. The legacy /documents page stays routable but is unlinked.
    {
      title: "Knowledge Bases",
      url: "/knowledge-bases",
      icon: BookOpen,
      description: "Folders of documents your agents can draw on",
    },
    {
      title: "Insights",
      url: "/insights",
      icon: Sparkles,
      description: "Track and monitor user activities across teams",
    },
    {
      title: "Data Tables",
      url: "/data-tables",
      icon: Table2,
      description: "Create structured tables to store and manage records",
    },
    {
      title: "Integrations",
      url: "/integrations",
      icon: Combine,
      description: "Connect and manage your integrations",
    },
    {
      title: "Scheduled Jobs",
      url: "/scheduled-job",
      icon: CalendarClock,
      description: "View all scheduled jobs across the platform",
    },

    // {
    //   title: "Usage ",
    //   url: "/usage",
    //   icon: PieChart,
    //   description: "Monitor your platform usage and analytics",
    // },
    // {
    //   title: "Interactions ",
    //   url: "/interactions",
    //   icon: GitCompareArrows,
    //   description: "View and manage all interactions",
    // },

    {
      title: "Blueprints",
      url: "/blueprints",
      icon: DraftingCompass,
      description: "Manage and configure platform blueprints and templates",
    },
    {
      title: "Billing & Usage",
      url: "/billing",
      icon: Coins,
      description: "View and manage your billing and usage"
    },
    {
      title: "Settings",
      url: "/settings",
      icon: Settings2,
      description: "Configure your platform settings",
    },
    {
      title: "Help",
      url: "/help",
      icon: CircleHelp,
      description: "Get help and support documentation",
    },

  ],
};

export const SuperAdminData = {
  teams: [
    {
      name: "Implement AI",
      logo: "/logos/iai-logo.png",
    },
  ],
  navMain: [
    {
      title: "Organisations",
      url: "/super-admin/organizations",
      icon: Database,
      description: "Manage all organizations in the platform",
    },
    {
      title: "Organisations Details",
      url: "/super-admin/organisation-detail",
      icon: Database,
      description: "View detailed organization information and billing",
    },
    {
      title: "Partners",
      url: "/super-admin/partners",
      icon: Handshake,
      description: "Manage platform partners, their pricing and access level",
    },
    // {
    //   title: "Activity Logs",
    //   url: "/super-admin/activity-logs",
    //   icon: Activity,
    //   description: "Monitor all platform activities",
    // },
    // {
    //   title: "Usage ",
    //   url: "/super-admin/usage",
    //   icon: PieChart,
    //   description: "View platform usage analytics",
    // },
    {
      title: "Blueprints",
      url: "/super-admin/blueprints",
      icon: FileText,
      description: "Manage and configure platform blueprints and templates",
    },
    {
      title: "Billing Plan",
      url: "/super-admin/billing-plan",
      icon: CreditCard,
      description: "Manage subscription plans and addons",
    },
    
          {
            title: "Aios Assistant",
            url: "/super-admin/aios-assistant",
            icon: Bot,
            description: "AI assistant for super admin tasks and support",
          },
       
    {
      title: "Command",
      url: "/super-admin/command-team",
      icon: Puzzle,
      description: "Publish AIOS skills, presets, and categories",
    },
    {
      title: "Security",
      url: "/super-admin/security",
      icon: Settings2,
      description: "Manage guardrails and security settings for all team types",
    },
  ],
};

export const AnalystTeamSidebarItems = [
  {
    title: "Analyst Agents",
    url: "/workforce/analyst-team/analyst-agent",
    icon: LayoutPanelLeft,
    description: "Manage and customize analyst agents here",
  },
  {
    title: "Activity Log",
    url: "/workforce/analyst-team/analyst-activity-log",
    icon: Activity,
    description: "View and manage analyst activity logs",
  },
  {
    title: "File Manager",
    url: "/workforce/analyst-team/analyst-file-manager",
    icon: File,
    description: "Access and organize analyst files",
  },
];

export const SalesTeamSidebarItems = [
  // {
  //   title: "Dashboard",
  //   url: "/dashboard",
  //   icon: Command,
  // },
  {
    title: "Sales Agents",
    url: "/workforce/sales-team/sales-agents",
    icon: Send,
    description: "Add, edit, and manage agents",
  },
  {
    title: "Squads",
    url: "/workforce/sales-team/squads",
    icon: Waypoints,
    description: "Agents that pass one call between them",
  },
  {
    title: "Activity Log",
    url: "/workforce/sales-team/sales-activity-log",
    icon: Activity,
    description: "Manage your activity logs",
  },
  // {
  //   title: "Activity Log",
  //   url: "/agents/support-team",
  //   icon: Send,
  // },
];

export const SupportTeamSidebarItems = [
  {
    title: "Support Agents",
    url: "/workforce/support-team/support-agents",
    icon: Headset,
    description: "Add and edit support agents",
  },
  {
    title: "Squads",
    url: "/workforce/support-team/squads",
    icon: Waypoints,
    description: "Agents that pass one call between them",
  },
  {
    title: "Activity Log",
    url: "/workforce/support-team/support-activity-log",
    icon: Activity,
    description: "Manage your activity logs",
  },
  // {
  //   title: "Activity Log",
  //   url: "/agents/support-team",
  //   icon: Send,
  // },
];

export const TasksTeamSidebarItems = [
  {
    title: "Task Agents",
    url: "/workforce/tasks-team/task-agents",
    icon: LayoutPanelLeft,
    description: "Manage and customise Task Agent here",
  },
  {
    title: "Tasks Runs",
    url: "/workforce/tasks-team/tasks-runs",
    icon: ListStart,
    description: "View and manage task runs",
  },

  {
    title: "Activity Log",
    url: "/workforce/tasks-team/tasks-activity-log",
    icon: Activity,
    description: "Manage your activity logs",
  },
];



export const CommandTeamSidebarItems = [
  {
    title: "Agents",
    url: "/workforce/command-team-old/agents",
    icon: LayoutPanelLeft,
    description: "Manage and customise Command Agents here",
  },
  {
    title: "Activity Log",
    url: "/workforce/command-team-old/activity-logs",
    icon: Activity,
    description: "Manage your activity logs",
  },
];  
